export const PHONE = "919928281132";
export const PHONE_DISPLAY = "+91 99282 81132";
export const EMAIL = "fizahasny@gmail.com";
export const GOOGLE_BUSINESS_URL = "https://share.google/yF456PplSP1viZkhY";
